
import React from "react";
import img1 from "./imgs/C3.jpg";
// import img2 from "./imgs/C3-1.jpg";
import img3 from "./imgs/15.M-Cure 3-c.jpg"
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/C3.jpg";
import img2en from "./imgs/MC3.jpeg";
import img3en from "./imgs/15-M-Cure 3.jpg"

export function MCure3() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img3}/>
                    <img className="product-img" src={img1}/>

                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                    <img className="product-img" src={img3en}/>
                </>
            }
        </>
    )
}